export const EVENT_TYPE = {
  PRE_REGISTER_OPEN_DIALOG_ERROR: '@global-account-fe/pre-register/open-dialog-error',
  PERSONAL_DATA_OPEN_DIALOG_EMAIL_ALREADY_EXISTS_ERROR: '@global-account-fe/personal-data/open-dialog-email-already-exists-error',
}
